import { apiFetch } from "./apiClient";
import type { AuditFields } from "./audit";

/** Maps to the backend's BuildingDto — the real, live Buildings resource. */
export interface BuildingDto extends AuditFields {
  buildingId: number;
  accountId: number;
  branchId: number | null;
  buildingName: string | null;
  description: string | null;
}

export interface BuildingPayload {
  accountId: number;
  branchId: number | null;
  buildingName: string | null;
  description: string | null;
}

export const listBuildings = async (): Promise<BuildingDto[]> => {
  const res = await apiFetch("/buildings");
  return res.json();
};

export const createBuilding = async (
  payload: BuildingPayload
): Promise<BuildingDto> => {
  const res = await apiFetch("/buildings", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateBuilding = async (
  buildingId: number,
  payload: BuildingPayload
): Promise<void> => {
  await apiFetch(`/buildings/${buildingId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

export const deleteBuilding = async (buildingId: number): Promise<void> => {
  await apiFetch(`/buildings/${buildingId}`, { method: "DELETE" });
};
